import repository from './repository';
import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let BlockRepository = repository('/block');

BlockRepository.getAllBlocks = () => {
    return axios.get(API + '/block/get_all_blocks');
};

BlockRepository.getAllFlowTemplates = () => {
    return axios.get(API + '/block/get_flow_templates');
};

BlockRepository.getAllMethodsForBlock = (blockName, blockType) => {
    return axios.post(API + '/block/methods', {blockName: blockName, blockType: blockType});
};

BlockRepository.getInfoForBlock = (blockName, blockType) => {
    return axios.post(API + '/block/info', {blockName: blockName, blockType: blockType});
};

BlockRepository.getMethodsDetailForBlock = (blockName, blockType) => {
    return axios.post(API + '/block/methods/detail', {blockName: blockName, blockType: blockType});
};

export default BlockRepository;
